
import type { BaseErrorResponse, CSDirectSendReq, CSDirectSendRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useCs() {
  class Cs<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Communication service
     * @name CsControllerDirectSendMessage
     * @summary Sending a message through a communication service (CS)
     * @request POST:/api3/cs/directsend
     * @secure
     * @response `200` `CSDirectSendRes`
     * @response `400` `BaseErrorResponse`
     */
    csControllerDirectSendMessage = (data: CSDirectSendReq, params: RequestParams = {}) =>
      this.request<CSDirectSendRes, BaseErrorResponse>({
        path: '/api3/cs/directsend',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Cs();
}
